import classes from "./Row_user.module.css";
import {Button} from "@mui/material";
import {useState} from "react";

const Row_user = (props) => {
    const [data] = useState(props.data);

    const handleEdit = () => {
        props.onEdit(data);
    };

    const handleDelete = () => {
        if (props.onDeleteRequest) {
            props.onDeleteRequest(data);
        } else if (props.onDelete) {
            props.onDelete(data.id);
        }
    };

    return (
        <div className={classes.row}>
            <div className={classes.column}>{data.username}</div>
            <div className={classes.column}>{data.name || data.organizationName || 'N/A'}</div>
            {props.canManageUsers && (
                <div className={classes.columnActions}>
                    <Button 
                        onClick={handleEdit} 
                        color="primary" 
                        variant="outlined"
                        size="small"
                    >
                        Edit
                    </Button>
                    <Button 
                        onClick={handleDelete} 
                        color="error" 
                        variant="outlined"
                        size="small"
                    >
                        Delete
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Row_user;
